import React, { useCallback, useContext, useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Autocomplete, Box, Button, Card, CardContent, Container, Divider, Grid, TableBody, TextField, Typography } from "@mui/material";
import { ContextNotification, severitys } from '../../../App';
import { ContextUserInfo } from '../MainPanel';
import { RHFAutocomplete } from '../../../Components/RHFAutocomplete';
import BeatLoading from '../../../Components/Loader/BeatLoader';
import staticVariablesApi from '../../../api/staticVariablesApi';
import helper from '../../../helper';
import guestRequestApi from '../../../api/guestRequestApi';
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import CustomDateInput from '../../../Components/CustomDateInput';
import moment from 'jalali-moment'
import enumMapper from '../../../enumMapper';
import stationApi from '../../../api/stationApi';
import CheckboxListFlex from './CheckboxListFlex';
import guestServicesDetailsApi from '../../../api/guestServicesDetailsApi';
import guestGroupApi from '../../../api/guestGroupApi';
import { EmailRegex } from '../../../Regex';

const AddMemberToGroup = ({ category, ageTypeArabianDropDown, refreshGrid }) => {
    const { open, setOpen } = useContext(ContextNotification);
    const { userInfo, userPermissions, userRoles } = useContext(ContextUserInfo);
    const [rows, setRows] = useState([]);
    const [refresh, setRefresh] = useState(false);
    const [loadingRows, setLoadingRows] = useState(false);
    const [loading, setLoading] = useState(true);
    const [submitLoading, setSubmitLoading] = useState(false);

    const schema = yup.object().shape({

         name: yup.string().required("نام را وارد کنید"),
                family: yup.string().required("نام خانوادگی را وارد کنید"),
                passNO: yup.string().required("شماره گذرنامه را وارد کنید").max(10, "حداکثر 10 رقم وارد نمایید"),
                fatherName: yup.string().required("نام پدر را وارد نمایید"),
                mBirthDate: yup.string().required("تاریخ تولد را وارد کنید"),
                ageCategory: yup.string().required("گروه سنی را انتخاب نمایید"),
                address: yup.string().required("آدرس محل سکونت را وارد کنید"),
                ssn: yup.string().nullable().max(10, "10 رقم وارد نمایید").trim()
                    .test("SSNValidaton", "کد ملی صحیح نیست", (value) => SSNValidator(value)),
                mobileNO: yup.string().nullable().max(11, "حداکثر 11 رقم وارد نمایید"),
                emailAddress: yup
    .string()
    .trim()
    .notRequired() // ← makes it optional
    .matches(EmailRegex, { message: "فرمت ایمیل صحیح نیست", excludeEmptyString: true }),

    }
    );
    const { register, handleSubmit, formState: { errors }, control, watch, setValue, resetField } = useForm({
        defaultValues: {

        },
        resolver: yupResolver(schema),
    });

    function GetGregorianDate(input) {
        let dateGregorian = null;
        if (input) {
            let date = new DateObject({
                date: input,
                calendar: persian,
                locale: persian_fa
            });

            var dateStr = date.year + '/' + date.month.number + '/' + date.day;
            dateGregorian = moment.from(dateStr, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD')
        }
        return dateGregorian
    }

    const onSubmit = (data) => {

 let mBirthDateGregorian = null;
 if(data.mBirthDate){
            let mBirthDate = new DateObject({
                date: data.mBirthDate,
                calendar: persian,
                locale: persian_fa
            });

            var mBirthDateStr = mBirthDate.year + '/' + mBirthDate.month.number + '/' + mBirthDate.day;
            mBirthDateGregorian = moment.from(mBirthDateStr, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD')
        }


        const newData = {

            "name": data.name,
            "family": data.family,
            "fatherName": data.fatherName,
            "ssn": data.ssn,
            "passNO": data.passNO,
            "mBirthDate": mBirthDateGregorian,
            "ageCategory":Number(data.ageCategory),
            "emailAddress": data.emailAddress,
            "mobileNO": data.mobileNO,
            "address": data.address,
     

        }
        guestGroupApi.AddMemberToGroup(category?.id, newData).then(res => {
            if (res.data.success) {
                setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.success });
                refreshGrid(true)
                resetForm()
            }
            else {
                setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.error });
            }
        }).catch(err => {
            if (err.response && err.response.data && err.response.data.errors) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
            }
            else if (err.response && err.response.data) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
            }
            else if (err.message) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
            }
            else {
                setOpen({ IsEnable: true, Message: JSON.stringify(err), severity: severitys.error });
            }
        }
        ).finally(() => { setSubmitLoading(false); });
    };
    useEffect(() => {

    }, []);




    const handleAgeTypeArabianChanged = (id) => { }


    const RefreshGrid = (result) => {
        if (result)
            setRefresh(old => !old);
    }

    const resetForm = () => {
resetField("name");
resetField("family");
resetField("fatherName");
resetField("ssn");
resetField("passNO");
resetField("mBirthDate");
resetField("ageCategory");
resetField("emailAddress");
resetField("mobileNO");
resetField("address");
    }

  const SSNValidator = (val) => {
        if (!val)
            return true;
        else
            return helper.SSNValidator(val)
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={2}>
                {/* شهر */}
                <Grid item xs={12} md={6}>

                </Grid>

                {/* سرویس */}
                <Grid item xs={12} md={6}>

                </Grid>



            </Grid>



            <Grid container spacing={2}>
                <Grid item md={4}>
                    <TextField
                        fullWidth
                        placeholder="نام"
                        {...register(`name`)}
                        sx={{
                            "& .MuiInputBase-root": {
                                padding: 0,
                            },
                            "& .MuiOutlinedInput-root": {
                                height: 40
                            },
                            "& .MuiInputBase-input": {
                                padding: "0 14px",
                                lineHeight: "40px"
                            }
                        }}
                        error={!!errors?.name}
                        helperText={errors?.name?.message}
                    />
                </Grid>
                <Grid item md={4}>
                    <TextField
                        fullWidth
                        placeholder="نام خانوادگی"
                        {...register(`family`)}
                        sx={{
                            "& .MuiInputBase-root": {
                                padding: 0,
                            },
                            "& .MuiOutlinedInput-root": {
                                height: 40
                            },
                            "& .MuiInputBase-input": {
                                padding: "0 14px",
                                lineHeight: "40px"
                            }
                        }}
                        error={!!errors?.family}
                        helperText={errors?.family?.message}
                    />
                </Grid>
                <Grid item md={4}>
                    <TextField
                        fullWidth
                        placeholder="شماره گذرنامه"
                        {...register(`passNO`)}
                        sx={{
                            "& .MuiInputBase-root": {
                                padding: 0,
                            },
                            "& .MuiOutlinedInput-root": {
                                height: 40
                            },
                            "& .MuiInputBase-input": {
                                padding: "0 14px",
                                lineHeight: "40px"
                            }
                        }}
                        error={!!errors?.passNO}
                        helperText={errors?.passNO?.message}
                    />
                </Grid>
                <Grid item md={4}>
                    <TextField
                        fullWidth
                        placeholder="نام پدر"
                        {...register(`fatherName`)}
                        sx={{
                            "& .MuiInputBase-root": {
                                padding: 0,

                            },
                            "& .MuiOutlinedInput-root": {
                                height: 40
                            },


                            "& .MuiInputBase-input": {
                                padding: "0 14px",
                                lineHeight: "40px"
                            }
                        }}
                        error={!!errors?.fatherName}
                        helperText={errors?.fatherName?.message}
                    />
                </Grid>
                <Grid item md={4}>
                    <Controller
                        control={control}
                        name={`mBirthDate`}
                        rules={{ required: true }}
                        render={({
                            field: { onChange, name, value },
                            fieldState: { invalid, isDirty },
                        }) => (
                            <>
                                <DatePicker
                                    value={value || ""}
                                    onChange={(date) => {
                                        onChange(date?.isValid ? date : "");
                                    }}
                                    format={"YYYY/MM/DD"}
                                    calendar={persian}
                                    locale={persian_fa}
                                    calendarPosition="bottom-right"
                                    render={<CustomDateInput label={"تاریخ تولد"}
                                        sx={{
                                            "& .MuiInputBase-root": {
                                                padding: 0,
                                            },
                                            "& .MuiOutlinedInput-root": {
                                                height: 40
                                            },
                                            "& .MuiInputBase-input": {
                                                padding: "0 14px",
                                                lineHeight: "40px"
                                            }
                                        }}
                                        error={!!errors?.mBirthDate}
                                        helperText={errors?.mBirthDate?.message}
                                    />}
                                />
                            </>
                        )}
                    />
                </Grid>
                <Grid item md={4}>
                    <TextField
                        fullWidth
                        placeholder="ایمیل (اختیاری)"
                        {...register(`emailAddress`)}
                        sx={{
                            "& .MuiInputBase-root": {
                                padding: 0,

                            },
                            "& .MuiOutlinedInput-root": {
                                height: 40
                            },


                            "& .MuiInputBase-input": {
                                padding: "0 14px",
                                lineHeight: "40px"
                            }
                        }}
                        error={!!errors?.emailAddress}
                        helperText={errors?.emailAddress?.message}
                    />
                </Grid>
                <Grid item md={4}>
                    <RHFAutocomplete
                        control={control}
                        options={ageTypeArabianDropDown ?? []}
                        name={`ageCategory`}
                        placeholder="گروه سنی"
                        onChange={handleAgeTypeArabianChanged}
                        style={{
                            border: "none",
                            padding: 0
                        }}
                        sx={
                            {
                                "& .MuiInputBase-root": {
                                    padding: 0,

                                },
                                "& .MuiOutlinedInput-root": {
                                    height: 40,
                                    minWidth: 185
                                },
                                "& .MuiInputBase-input": {
                                    padding: "0 14px",
                                    lineHeight: "40px",

                                }
                            }
                        }
                        error={!!errors?.ageCategory}
                        helperText={errors?.ageCategory?.message}
                    />
                </Grid>
                <Grid item md={4}>
                    <TextField
                        fullWidth
                        placeholder="کد ملی (اختیاری)"
                        {...register(`ssn`)}
                        sx={{
                            "& .MuiInputBase-root": {
                                padding: 0,
                            },
                            "& .MuiOutlinedInput-root": {
                                height: 40
                            },
                            "& .MuiInputBase-input": {
                                padding: "0 14px",
                                lineHeight: "40px"
                            }
                        }}
                        error={!!errors?.ssn}
                        helperText={errors?.ssn?.message}
                    />
                </Grid>
                <Grid item md={4}>
                    <TextField
                        fullWidth
                        placeholder="شماره موبایل (اختیاری)"
                        {...register(`mobileNO`)}
                        sx={{
                            "& .MuiInputBase-root": {
                                padding: 0,
                            },
                            "& .MuiOutlinedInput-root": {
                                height: 40
                            },
                            "& .MuiInputBase-input": {
                                padding: "0 14px",
                                lineHeight: "40px"
                            }
                        }}
                        error={!!errors?.mobileNO}
                        helperText={errors?.mobileNO?.message}
                    />
                </Grid>
                <Grid item md={12}>
                    <TextField
                        fullWidth
                        placeholder="آدرس محل سکونت"
                        {...register(`address`)}
                        sx={{
                            "& .MuiInputBase-root": {
                                padding: 0,
                            },
                            "& .MuiOutlinedInput-root": {
                                height: 40
                            },
                            "& .MuiInputBase-input": {
                                padding: "0 14px",
                                lineHeight: "40px"
                            }
                        }}
                        error={!!errors?.address}
                        helperText={errors?.address?.message}
                    />
                </Grid>
            </Grid>













            {/* دکمه ثبت */}
            <Box textAlign="center" mt={5}>
                <Button
                    type="submit"
                    variant="contained"
                    size="large"
                    sx={{
                        px: 6,
                        py: 1.2,
                        borderRadius: 3,
                        fontWeight: 600
                    }}
                    disabled={submitLoading}
                >
                    {submitLoading
                        ? <BeatLoading loading color="#fff" size={8} />
                        : "ثبت"}
                </Button>
            </Box>
        </form>

    )
}
export default AddMemberToGroup;